import axios from "axios";
import { useEffect, useState } from "react";

interface DepositItem {
  uid: string;
  transaction_id: number;
  transaction_date: string;
  name: string;
  amount: number;
  status: string;
  utr_no: string;
}

const PanelDeposits = () => {
  const [isManualPayment, setIsManualPayment] = useState(true); // To toggle between manual and online payments
  const [depositData, setDepositData] = useState<DepositItem[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTerm2, setSearchTerm2] = useState("");



  const filteredDeposits = depositData.filter((deposit) =>
    [deposit.name, deposit.uid, deposit.utr_no].some((field) =>
      field?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  const filteredDeposits2 = depositData.filter((deposit) =>
    [deposit.name, deposit.uid, deposit.utr_no].some((field) =>
      field?.toString().toLowerCase().includes(searchTerm2.toLowerCase())
    )
  );

  // Fetch data from the API based on transaction type
  const fetchDepositData = async () => {
    try {
      const transactionType = mode === "manual" ? "manual" : "online"; // Set transaction type based on state
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/getManualDepositData`,
        {
          params: { transactionType },
        }
      );
      const data = response.data;

      if (Array.isArray(data)) {
        const reversedData = data.reverse(); // Optionally reverse data for most recent first
        setDepositData(reversedData);
      } else {
        console.error("Unexpected response structure:", data);
        setDepositData([]);
      }
    } catch (error) {
      console.error("Failed to fetch deposit data:", error);
      setDepositData([]);
    }
  };


  return (
    <div className="ml-0 lg:ml-[256px] ">
      <>
        <div className="flex items-center justify-between p-4 bg-[#101828] dark:bg-[#101828] rounded-t-lg">
          <h2 className="text-xl font-bold text-white">
            Automatic Payment Details
          </h2>
          <div className=" flex justify-end items-center">
            <label htmlFor="search" className="sr-only">
              Search
            </label>
            <div className="relative">
              <input
                type="text"
                id="search"
                className="bg-[#101828] w-full pl-10 pr-4 py-2 rounded-lg border  shadow-sm focus:outline-none text-white"
                placeholder="Search by name or UID"
                value={searchTerm2}
                onChange={(e) => setSearchTerm2(e.target.value)}
              />
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg
                  className="h-5 w-5 text-gray-500"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="overflow-x-auto custom-scrollbar relative shadow-md sm:rounded-lg bg-[#101828]">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-white uppercase bg-[#394a6a]">
              <tr>
                <th className="py-3 px-6">SNo.</th>
                <th className="py-3 px-6">User Name</th>
                <th className="py-3 px-6">Amount</th>
                <th className="py-3 px-6">UTR No</th>
                <th className="py-3 px-6">Status</th>
                <th className="py-3 px-6">Date</th>
                <th className="py-3 px-6">Actions</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {filteredDeposits2.map((deposit, index) => (
                <tr
                  key={deposit.transaction_id}
                  className="group bg-[#101828] border-b border-gray-200 "
                >
                  <td className="text-white  py-4 px-6">{index + 1}</td>
                  <td className="text-white  py-4 px-6">{deposit.name}</td>
                  <td className="text-white  py-4 px-6">
                    ৳ {deposit.amount.toFixed(1)}
                  </td>
                  <td className="text-white  py-4 px-6">{deposit.utr_no}</td>
                  <td
                    className={`py-4 px-6 capitalize ${deposit.status.toLowerCase() === "accepted"
                        ? "text-green-500"
                        : deposit.status.toLowerCase() === "rejected"
                          ? "text-red-500"
                          : "text-yellow-500"
                      }`}
                  >
                    {deposit.status}
                  </td>
                  <td className="text-white  py-4 px-6">
                    {new Date(deposit.transaction_date).toLocaleString()}
                  </td>
                  <td className="py-4 px-6">
                    {deposit.status === "pending" ? (
                      <>
                        <button
                          className="px-3 py-1 bg-yellow-500 text-white rounded"
                        // onClick={() => handleRejectPayment(deposit.transaction_id, deposit.utr_no, deposit.uid, deposit.amount, 'inr')}
                        >
                          Pending
                        </button>
                      </>
                    ) : deposit.status === "accepted" ? (
                      <button className="px-3 py-1 mr-2 bg-[#228BE6] text-white rounded">
                        Success
                      </button>
                    ) : (
                      <button className="px-3 py-1 mr-2 bg-red-500 text-white rounded">
                        Rejected
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    </div>
  );
};

export default PanelDeposits;
